export const config = {
  apiEndpoint: 'apiEndpoint',
  apiVersion: '/v1/executions',
  isAiBannerHidden: 'isAiBannerHidden',

  overrides: '$tkOverrides',
};
